import "bootstrap-icons/font/bootstrap-icons.css";
import { EnquiryButton } from "components/buttons";
import { Jumbotron } from "sections";

function Career() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Careers"
          title={`
            <span className="jumbotron-subtitle-2">
              Careers
            </span>`}
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-3">
            <h2>
              <b>Ready to take charge of your career</b>
            </h2>
          </div>
          <div className="col-xl-7">
            <p>
              At alrajhi bank Malaysia, our teams are made up of passionate
              individuals and our employees are our greatest strength. We are
              giving highly motivated & determined individuals an opportunity to
              explore possibilities of growing with us. With alrajhi bank
              Malaysia’s exciting career options, you will work in a conducive,
              progressive environment alongside dynamic young individuals. More
              importantly, you will also gain the necessary experience to
              develop.
            </p>

            <p>
              So, if you are looking for a career in a bank that's unlike any
              other, look no further than alrajhi bank Malaysia. Join an
              innovative workforce that will challenge, energize and motivate
              you to be your very best.
            </p>
            <div className="row g-3">
              <div className="col-12 custom-column-2">
                <div className="column-header-2">
                  Building a promising future together
                </div>
                <div className="column-subheader-2">
                  Looking to build a career with alrajhi bank Malaysia? Simply
                  drop your resume to{" "}
                  <a href="mailto:careers@alrajhibank.com.my">
                    careers@alrajhibank.com.my
                  </a>
                </div>
              </div>
              <div className="col-12 custom-column-2">
                <div className="column-header-2">
                  Employee Reference Requests
                </div>
                <div className="column-subheader-2">
                  On matters pertaining to Employee Reference requests, kindly
                  email your queries to{" "}
                  <a href="mailto:hr@alrajhibank.com.my">
                    hr@alrajhibank.com.my
                  </a>
                  .
                  <br />
                  <br />
                  The dedicated personnel to attend to your queries are En
                  Rashid Rosman & Cik Nur Rasyiqah Mohd Amali from the Human
                  Resources Division.
                </div>
              </div>
            </div>
          </div>
          <div className="col-9 d-flex justify-content-center pt-5">
            <EnquiryButton
              text="Send us your resumes"
              email="hr@alrajhibank.com.my"
              subject="Job Application"
              body="Please find my resume attached."
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Career;
